export default __webpack_public_path__ + "static/media/Mhz_logo.6ed6577c.gif";